export const pdfBladenMixin = {
  data() {
    return {
      bladen: [
        { text: "Voorblad", value: "voorblad" },
        { text: "Unitgegevens", value: "inventarisatie" },
        { text: "Inspectieresultaten", value: "inspectie" },
        { text: "Inspectieresultaten NEN 2767", value: "inspectieNEN" },
        { text: "Condities", value: "condities" },
        { text: "Historie -3 tot 6 jaar", value: "historie" },
        { text: "Prognose 0 tot 9 jaar", value: "prognose10" },
        { text: "Prognose 10 tot 19 jaar", value: "prognose20" },
        { text: "Prognose 20 tot 29 jaar", value: "prognose30" },
        { text: "Gebreken", value: "gebreken" },
        { text: "Onderhoud", value: "onderhoud" },
        { text: "Foto's", value: "fotos" },
        { text: "Debug sheet", value: "debug-info" },
      ]
    };
  },
  methods: {
    getOrderedSheets(sheets) {
      return this.bladen
        .filter((i, index, array) => {
          if (sheets.includes(i.value)) return i;
        })
        .map(item => item.value);
    }
  }
};
